import styled from 'styled-components';
import { Img } from 'common/components';
import { resolveSpacersArray } from '../../../../common/styles/utils';

const BlogImagePreview = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => theme.color.blueLight};
  padding: ${({ theme }) =>
    resolveSpacersArray(theme, [5, 'medium', 'medium', 'medium'])};
  margin: 0 auto;
  max-width: 400px;
  max-height: 300px;
  ${Img} {
    width: 100%;
    height: 100%;
  }

  &:after {
    content: 'Blog Image';
    position: absolute;
    top: 0;
    left: 0;
    padding: ${({ theme }) => theme.spacer.medium};
    font-size: ${({ theme }) => theme.font.size.tiny};
    color: ${({ theme }) => theme.color.greyDark};
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }
`;

export default BlogImagePreview;
